import { Spacer } from './Spacer';

// TODO: in v9, move styled() from Spacer.jsx to here
export var StyledSpacer = Spacer;